import React from 'react';

// IP tracking removed.
export const IPTrackingWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;
